export const sxStyle = {
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: {
      xs: '30px',
      sm: 0,
    },
    minHeight: {
      xs: 'auto',
      sm: '300px',
    },
  },

  noResultsText: {
    color: '#000000',
    fontWeight: 600,
    fontSize: '24px',
    p: '20px',
  },

  noCity: {
    color: '#000000',
    fontSize: '20px',
    fontWeight: 400,
    textAlign: 'center',
  },
};
